import { Field } from 'components/Wizards/Field/Field'
import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'

const GENDER_OPTIONS = [
  { key: 'all', label: 'All genders' },
  { key: 'women', label: 'Women' },
  { key: 'men', label: 'Men' },
] as const

type Props = {
  gender?: string
  onUpdate: (gender: string) => void
}

const Gender = ({ gender, onUpdate }: Props) => {
  return (
    <Field label="Gender" labelType="label" data-testid="gender-preferences">
      <Select
        aria-label="Audience gender"
        variant="secondary"
        selectedKey={gender || 'all'}
        onSelectionChange={(key) => onUpdate(key as string)}
        placeholder="Select gender"
        size="lg"
        useFullWidth
      >
        {GENDER_OPTIONS.map((option) => (
          <Item key={option.key}>{option.label}</Item>
        ))}
      </Select>
    </Field>
  )
}

export { Gender }
